import { Dialog, Spinner } from '@/components/ui';
import React, { useState } from 'react';
import { ImSpinner9 } from 'react-icons/im';
import { VscFile, VscFilePdf, VscFileZip } from 'react-icons/vsc';
const BYTE = 1000;
const getKB = (bytes) => Math.round(bytes / BYTE);

const FileIcon = ({ children }) => {
  return <span className="text-4xl">{children}</span>;
};

const FileItem = (props) => {
  const [dialogIsOpen, setIsOpen] = useState(false);
  const { file, children } = props;
  const { type, name, size } = file;
  const openDialog = () => {
    setIsOpen(true);
  };

  const onDialogClose = (e) => {
    setIsOpen(false);
  };

  const onDialogOk = (e) => {
    setIsOpen(false);
  };

  const renderThumbnail = () => {
    const isImageFile = type.split('/')[0] === 'image';
    if (isImageFile) {
      return <img className="upload-file-image" src={!!file.url ? file.url : URL.createObjectURL(file)} alt={`file preview ${name}`} />;
    }

    if (type === 'application/zip') {
      return (
        <FileIcon>
          <VscFileZip />
        </FileIcon>
      );
    }

    if (type === 'application/pdf') {
      return (
        <FileIcon>
          <VscFilePdf />
        </FileIcon>
      );
    }

    return (
      <FileIcon>
        <VscFile />
      </FileIcon>
    );
  };

  return (
    <>
      <div className="upload-file" onClick={openDialog}>
        <div className="flex">
          <div className="upload-file-thumbnail">{!!file.url ? renderThumbnail() : <Spinner size={40} indicator={ImSpinner9} />}</div>
          <div className="upload-file-info">
            <p className="upload-file-name">{name}</p>
            <span className="upload-file-size">{getKB(size)} kb</span>
          </div>
        </div>
        {children}
      </div>
      <Dialog isOpen={dialogIsOpen} onClose={onDialogClose} onRequestClose={onDialogClose}>
        <div className="text-right mt-6">
          <img src={!!file.url ? file.url : URL.createObjectURL(file)} alt={`file preview ${name}`} />
        </div>
      </Dialog>
    </>
  );
};

export default FileItem;
